export const theme = {
    colors: {
        primaryBg: "#FFFFFF",
        secondaryBg: "#191919",
        grayBg: "#c2c2c2e3",

        primaryText: "#42446e",
        secondaryText: "#666",
        darkGray: "#a7a7a7",
        darkColor: "#000",
        mailColor: "#1e0e62",
        badgeColor: "#018c0f",
        gradient: "linear-gradient(90deg, #13b0f5 2.6%, #e70faa 100%);",
        shadow: "2px 2px 100px 0 rgba(0, 0, 0, 0.2)",
        badge: "#018c0f",

        placeholderColor: "#495057",

        error: "red",
    },
    font: {
        secondFamily: "DM Sans",
    },

    media: {
        tablet: "screen and (max-width: 767px)",
        mobile: "screen and (max-width: 576px)",
        desktop: "screen and (min-width: 1234px)",
    },

    animations: {
        transition: "all 0.3s ease-in-out",
    }
}